import React from 'react';

import ScreenBase from 'components/ScreenBase/ScreenBase';

const NoAccessScreen = () => <ScreenBase title='noAccess' />;

export default NoAccessScreen;
